<div class="min-h-[100vh] bg-gray-100 text-gray-900 flex justify-center">
  <div class="max-w-screen-xl max-h-[70vh] sm:m-10 bg-white shadow sm:rounded-lg flex justify-center flex-1"
    style="margin: auto;">

    <!-- LEFT PANEL -->
    <div class="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
      <div class="flex justify-center items-center space-x-4">
        <img class="h-24 p-2 my-0" [src]="tenant.getTenantLogoUrl()" alt="Tenant Logo" />
        <div class="h-24 border-l-2 border-gray-400 mx-4"></div>
        <img class="h-24 p-2 my-0" [src]="tenant.getCCMSLogoUrl()" alt="Partner Logo" />
      </div>

      <div class="mt-4 flex flex-col items-center">
        <div class="w-full flex-1 mt-8">
          <div class="mx-auto max-w-sm p-6">
            <div class="w-full mb-5">
              <h2 class="text-2xl font-semibold">Welcome</h2>
              <span class="text-gray-600 font-medium mt-2">Sign in to continue...</span>
            </div>

            <form (ngSubmit)="login()" [formGroup]="loginForm" class="space-y-6">
              <!-- Username -->
              <app-form label="Username" for="username" type="text" [showError]="showError('username')"
                [error]="getErrorMessage('username')" [mandatory]="true">
                <input pInputText type="text" id="username" name="username" formControlName="username"
                  placeholder="Enter Username" />
              </app-form>

              <!-- Password -->
              <app-form label="Password" for="password" type="text" [showError]="showError('password')"
                [error]="getErrorMessage('password')" [mandatory]="true">
                <div class="relative">
                  <input pInputText [type]="passwordFieldType" id="password" name="password" formControlName="password"
                    placeholder="Enter Password" class="w-full" />
                  <i class="pi" [ngClass]="{
                      'pi-eye': passwordFieldType === 'password',
                      'pi-eye-slash': passwordFieldType === 'text'
                    }" (click)="togglePasswordVisibility()"
                    style="cursor: pointer; position: absolute; right: 10px; top: 50%; transform: translateY(-50%);">
                  </i>
                </div>
              </app-form>

              <!-- Submit Button -->
              <button type="submit" class="w-full px-4 py-2 text-white rounded-md hover:underline focus:outline-none focus:bg-blue-700
                       disabled:opacity-50 disabled:cursor-not-allowed transition" [disabled]="loggingIn" [ngStyle]="{
                  backgroundColor: 'var(--primary)'
                }">
                {{ loggingIn ? 'Signing in...' : 'Sign In' }}
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT PANEL -->
    <div class="flex-1 bg-primary opacity-100 text-center hidden lg:flex"
      style="background-size: cover; background-position: right;">
      <div class="w-full bg-contain bg-center bg-no-repeat">
        <img [src]="sideImageUrl" alt="Login Image" class="mx-auto h-full" />
      </div>
    </div>
  </div>
</div>

<footer class="sticky bottom-0 w-full bg-white py-4 shadow-md ">
  <app-footer layout-footer></app-footer>
</footer>
